import dateFormat from 'dateformat'
import timestamp from "unix-timestamp";
import {DateTime} from "luxon";

const isString = x => typeof x === 'string'

const isValidDate = string => /\d{4}-\d{2}-\d{2}/.test(string)
const isValidUrl = string => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-._~:/?#[\]@!\$&'()\*\+,;=.{}]+$/g.test(string);

const length = x => x.length
const zeroLength = x => length(x) === 0
const duplicate = (y) => y.filter((v, i) => y.indexOf(v) === i)

const isEmptyString = x => isString(x) && zeroLength(x)

const reFormatJSON = x => JSON.parse(JSON.stringify(x))
const cloneObject = x => Object.assign({}, x)
const cloneObjectArray = x => x.map(cloneObject)

const isNull = x => x === null
const isTruthyOrNull = x => x || isNull(x)

const assignPositions = xs =>
    xs.map((x, position) => Object.assign({}, x, {position}))

const getCookie = (name) => {
  let value = '; ' + document.cookie
  let parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const deleteCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

const formatData = (date) => {
  return dateFormat(date, 'yyyy-mm-dd H:MM:ss')
}

const catchHandler = (e) => {
  deleteCookie('accessToken')
  location.reload()
  console.log('err', e)
}

const updateDate = (payload) => {
  if (!payload.toDate) {
    payload.toDate = payload.fromDate
  }
  const today = DateTime.utc();
  let state = {};
  switch (payload.typeDate) {
    case 'Today':
      state.fromDate = ~~(today.startOf('day').valueOf() / 1000);
      state.toDate = ~~(today.endOf('day').valueOf() / 1000);
      break;
    case 'Yesterday':
      state.fromDate = ~~(today.minus({ days: 1 }).startOf('day').valueOf() / 1000);
      state.toDate = ~~(today.minus({ days: 1 }).endOf('day').valueOf() / 1000);
      break;
    case 'Week to date':
      // Week to date = Monday to today
      // Today we're Tuesday 18th, so Week to date would show Monday 17th - Tuesday 18th
      state.fromDate = ~~(today.startOf('week').valueOf() / 1000);
      state.toDate = ~~(today.endOf('day').valueOf() / 1000);
      break;
    case 'Month to date':
      // Month to date = 1st of this Month to today
      // Today's example would be Jan 1st - Jan 18th
      state.fromDate = ~~(today.startOf('month').valueOf() / 1000);
      state.toDate = ~~(today.endOf('day').valueOf() / 1000);
      break;
    case 'Year to day':
      // Year to date = 1st day of year to today
      // Today would be Jan 1st - Jan 18th
      state.fromDate = ~~(today.startOf('year').valueOf() / 1000);
      state.toDate = ~~(today.endOf('day').valueOf() / 1000);
      break;
    case 'fromDateCustom':
      state.fromDate = ~~(DateTime.fromFormat(payload.date, 'yyyy-MM-dd', {
        zone: 'utc'
      }).valueOf() / 1000);
      break;
    case 'toDateCustom':
      state.toDate = ~~(DateTime.fromFormat(payload.date, 'yyyy-MM-dd', {
        zone: 'utc'
      }).endOf('day').valueOf() / 1000);
      break;
    case 'Custom':
      state.fromDate = ~~(DateTime.fromFormat(payload.fromDate, 'yyyy-MM-dd', {
        zone: 'utc'
      }).valueOf() / 1000);
      state.toDate = ~~(DateTime.fromFormat(payload.toDate, 'yyyy-MM-dd', {
        zone: 'utc'
      }).endOf('day').valueOf() / 1000);
      break;
    case 'Last 7 days':
      // Last 7 days = today and previous 6 days
      state.fromDate = ~~(today.minus({ days: 6 }).startOf('day').valueOf() / 1000);
      state.toDate = ~~(today.endOf('day').valueOf() / 1000);
      break;
    case 'Last week':
      // Last Week = Previous Monday to Previous Sunday
      // Today we're Tuesday 18th, so Last Week would show Monday 10th - Sunday 16th
      const prevWeek = today.startOf('week').minus({ days: 1 });
      state.fromDate = ~~(prevWeek.startOf('week').valueOf() / 1000);
      state.toDate = ~~(prevWeek.endOf('week').valueOf() / 1000);
      break;
    case 'Last month':
      // Last Month = full previous month
      // so Dec 1st - Dec 31st
      const prevMonth = today.startOf('month').minus({ days: 1 });
      state.fromDate = ~~(prevMonth.startOf('month').valueOf() / 1000);
      state.toDate = ~~(prevMonth.endOf('month').valueOf() / 1000);
      break;
  }
  return state;
}

const createPeriod = (result, period) => {
  const dates = [];
  const conversions = [];

  for (let i = period; i >= 1; i--) {
    const date = DateTime.now().startOf('day').minus({days: i}).toISODate();
    dates.push(date);
    const dateData = (result && result.statuses && result.statuses.count)
        ? result.statuses.data.find(d => d.day === date)
        : null;
    conversions.push(dateData ? dateData.conversions : 0)
  }

  return { dates, conversions }
};

const getCurrencyList = () => {
  return [
    {id: 1, name: '$ (USD)', symbol: '$', abbr: 'USD'},
    {id: 2, name: '€ (EUR)', symbol: '€', abbr: 'EUR'},
    {id: 3, name: 'R$ (BRL)', symbol: 'R$', abbr: 'BRL'},
    {id: 4, name: '£ (GBP)', symbol: '£', abbr: 'GBP'},
  ]
};

const getMarginTypes = () => {
  return [
    {id: 1, name: 'fixed'},
    {id: 2, name: 'percent'},
    {id: 3, name: 'dynamic'},
    {id: 4, name: 'correction'},
  ]
};

async function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve({
        base64: reader.result,
        name: file.name
      });
    };
    reader.onerror = error => reject(error);
  });
}

const objectsEqual = (o1, o2) =>
    typeof o1 === 'object' && Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length
        && Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
        : o1 === o2;

const compareArrays = (a1, a2) =>
    a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));


function isObject(object) {
  return object != null && typeof object === 'object';
}

const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
        areObjects && !deepEqual(val1, val2) ||
        !areObjects && val1 !== val2
    ) {
      return false;
    }
  }

  return true;
};

const formatDateRange = (timestamps) => {
  if (!Array.isArray(timestamps) || timestamps.length !== 2) {
    throw new Error("Input must be an array with two timestamps");
  }

  const [start, end] = timestamps.map(ts =>
      DateTime.fromMillis(ts).toFormat("yyyy-MM-dd")
  );

  return [start, end];
};

export {
  isValidDate,
  isValidUrl,
  isEmptyString,
  duplicate,
  reFormatJSON,
  cloneObject,
  formatData,
  catchHandler,
  cloneObjectArray,
  getCookie,
  deleteCookie,
  isTruthyOrNull,
  assignPositions,
  updateDate,
  createPeriod,
  getCurrencyList,
  getMarginTypes,
  compareArrays,
  deepEqual,
  convertFileToBase64,
  formatDateRange
}

